module.exports = {
  useDecimal: false
};


// WEBPACK FOOTER //
// ./src/lib/config.js